export default {
    url: '/activity',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        title: 'Activity',
        role: 'rating_arena',
        priority: 805,
    },
};
